import { render, staticRenderFns } from "./bigImg.vue?vue&type=template&id=ba5b2336&scoped=true&"
import script from "./bigImg.vue?vue&type=script&lang=js&"
export * from "./bigImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5b2336",
  null
  
)

export default component.exports